module.exports = __webpack_public_path__ + "static/media/ic-close.586d2dfd.svg";